"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteGift = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 125 86",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M44.4032612,0 L44.4032612,6.8136178 L41.2920565,6.813 L41.2922047,26.6866697 L27.7166853,26.6866697 L27.7160565,10.504 L3.11105652,10.5043274 L3.11105652,6.8136178 L27.7160565,6.813 L27.7166853,0 L44.4032612,0 Z",
        id: "mysite-gift-path-1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        id: "mysite-gift-path-2",
        points: "4.52517312 4.54241187 13.5755193 4.54241187 13.5755193 13.6272356 4.52517312 13.6272356"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-gift-path-3",
        x: "15.8381059",
        y: "4.54241187",
        width: "18.1006925",
        height: "2.27120593"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-gift-path-4",
        x: "15.8381059",
        y: "9.08482374",
        width: "13.8583427",
        height: "2.27120593"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-gift-path-5",
        x: "4.52517312",
        y: "15.8984415",
        width: "6.78775967",
        height: "2.27120593"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-gift-path-6",
        x: "13.5755193",
        y: "15.8984415",
        width: "11.3129328",
        height: "2.27120593"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-gift-path-7",
        x: "27.1510387",
        y: "15.8984415",
        width: "6.78775967",
        height: "2.27120593"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-438.000000, -1044.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(438.000000, 1044.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M72.3038787,13.8554787 C64.3261485,13.5767163 56.7272617,10.9778262 49.4719763,8.13488342 C42.2166909,5.29194065 35.0285842,2.14094913 27.242478,0.634330475 C22.2338203,-0.334287567 16.5060214,-0.470957078 12.4709022,2.23748553 C8.58665946,4.84071432 7.33229244,9.34646947 6.65830416,13.5181436 C6.15061044,16.6637117 5.85216139,19.9665582 7.24198683,22.9082068 C8.20781638,24.9506567 9.9225218,26.6666183 11.1086089,28.6222939 C15.2329325,35.4286525 12.3200257,43.8218961 7.84659394,50.4677222 C5.75414677,53.5850886 3.31699641,56.5592774 1.69920437,59.8773096 C0.0814122733,63.1953417 -0.667463545,66.9982249 0.747691542,70.3835069 C2.15183371,73.7395027 5.49534409,76.2592113 9.11748026,78.0315763 C16.4751853,81.6327097 25.1456257,82.6631541 33.6002136,83.2467111 C52.3155017,84.5385634 71.1310071,83.9788695 89.8958535,83.4191751 C96.8405753,83.2109167 103.815032,83.001574 110.647423,81.9179801 C114.440259,81.3159832 118.356439,80.3614659 121.109659,78.0554394 C124.606248,75.1268069 125.472962,70.1730794 123.129421,66.5036117 C119.203329,60.3502293 108.336921,58.823002 105.590309,52.2151395 C104.07824,48.5792966 105.631056,44.5291065 107.828126,41.1514172 C112.541638,33.9176952 120.442278,27.5712403 120.858565,19.3016502 C121.1449,13.6222727 117.346558,7.93421786 111.47449,5.24746882 C105.31829,2.4273043 96.7833083,2.78524826 92.2415967,7.44719712 C87.565528,12.2555777 79.3477169,14.1027854 72.3038787,13.8554787 Z",
            fill: "#E6EDFB",
            fillRule: "nonzero",
            className: "fill-primary",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(63.069600, 57.347950)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#FFFFFF",
              x: "0",
              y: "0",
              width: "27.7166853",
              height: "6.8136178"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#FFFFFF",
              x: "3.11105652",
              y: "6.8136178",
              width: "24.6056288",
              height: "19.8730519"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-1"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.500327797",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-1"
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#A64A4A",
            transform: "translate(44.968908, 46.417771) scale(-1, 1) translate(-44.968908, -46.417771) ",
            points: "38.1811482 38.6105009 51.7566675 54.2250417 38.1811482 54.2250417"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#FF6E71",
            points: "38.1811482 38.6105009 51.7566675 54.2250417 38.1811482 54.2250417"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(17.252223, 49.398729)",
            className: "fill-primary-opa50",
            fill: "#88A9F0",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "0",
              y: "0",
              width: "34.504445",
              height: "9.93652597"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "3.67670316",
              y: "9.93652597",
              width: "29.6964486",
              height: "24.6993645"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M38.1811482,49.3987291 L38.1809257,59.3347291 L50.6249257,59.3347291 L50.6253742,49.3987291 L74.6653564,49.3987291 L74.6653564,59.3352551 L70.4229257,59.3347291 L70.4230066,84.0346196 L50.6253742,84.0346196 L50.6249257,64.1607291 L40.1599257,64.1607291 L40.1609114,84.0346196 L32.8075051,84.0346196 L32.8069257,64.1607291 L20.9289257,64.1615677 L20.9289257,59.3352551 L30.8269257,59.3347291 L30.8277418,49.3987291 L38.1811482,49.3987291 Z",
            className: "fill-primary",
            fill: "#1657E2"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(62.786777, 67.568377)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FDD33F",
                x: "0",
                y: "0",
                width: "10.7472861",
                height: "16.466243"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "0",
                width: "3.11105652",
                height: "16.466243"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFE168",
                x: "7.35340631",
                y: "0",
                width: "1.69693992",
                height: "16.466243"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "2.8282332",
                y: "4.54241187",
                width: "1.69693992",
                height: "2.83900742"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "2.8282332",
                y: "13.6272356",
                width: "1.69693992",
                height: "2.83900742"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "2.83900742",
                width: "10.7472861",
                height: "1.70340445"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "7.38141929",
                width: "10.7472861",
                height: "1.70340445"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "11.9238312",
                width: "10.7472861",
                height: "1.70340445"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              transform: "translate(7.353406, 2.839007)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FDD33F",
                x: "0",
                y: "1.70340445",
                width: "10.7472861",
                height: "11.9238312"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "0",
                width: "3.11105652",
                height: "13.6272356"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFE168",
                x: "7.63622963",
                y: "1.70340445",
                width: "1.4141166",
                height: "11.9238312"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "2.8282332",
                y: "6.24581632",
                width: "1.69693992",
                height: "2.83900742"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "4.54241187",
                width: "10.7472861",
                height: "1.70340445"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#F7B523",
                x: "0",
                y: "9.08482374",
                width: "10.7472861",
                height: "1.70340445"
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(65.615010, 18.737449)",
            className: "fill-primary",
            fill: "#1657E2",
            opacity: "0.197916667",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "0",
              y: "0",
              width: "38.4639715",
              height: "22.7120593",
              rx: "2.24448573"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(56.564664, 23.279861)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "4.2423498",
              y: "0",
              width: "36.4784342",
              height: "22.7120593",
              rx: "2.24448573"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#FFFFFF",
              x: "0",
              y: "0",
              width: "38.4639715",
              height: "22.7120593",
              rx: "2.24448573"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.504370629",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-2"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-3"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.504370629",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-3"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.504370629",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-4"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-5"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.504370629",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-5"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-6"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.504370629",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-6"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-gift-path-7"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.504370629",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-gift-path-7"
              })]
            })]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteGift')(IllustrationMySiteGift);